export default __webpack_public_path__ + "static/media/ABOUT.US.b304b130.jpg";